import React from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const QcDialog = ({ open, onClose, jobNo, qcForm, setQcForm, onSubmit }) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent data-testid="job-qc-dialog" className="max-w-sm">
      <DialogHeader><DialogTitle>QC Check — {jobNo}</DialogTitle></DialogHeader>
      <div className="space-y-3">
        <div>
          <Label className="text-xs">Result</Label>
          <Select value={qcForm.qc_result} onValueChange={(v) => setQcForm({ ...qcForm, qc_result: v })}>
            <SelectTrigger className="mt-1"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="pass">Pass</SelectItem><SelectItem value="fail">Fail</SelectItem><SelectItem value="pending">Pending</SelectItem></SelectContent>
          </Select>
        </div>
        <div><Label className="text-xs">Remarks</Label><Textarea value={qcForm.remarks} onChange={(e) => setQcForm({ ...qcForm, remarks: e.target.value })} rows={2} className="mt-1" /></div>
      </div>
      <DialogFooter><Button variant="outline" onClick={onClose}>Cancel</Button><Button onClick={onSubmit}>Save QC Result</Button></DialogFooter>
    </DialogContent>
  </Dialog>
);
